import styled from "styled-components";

export const ReportContextControlsLayout = styled.div`
  margin: 0.5em 20px 20px 20px;
`;

export const hoursOptions = [
  { label: "1 Day", value: 24 },
  { label: "1 Week", value: 168 },
  { label: "1 Month", value: 744 },
  { label: "3 Months", value: 2160 },
];